import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
export interface CommonMessage {
  id: number;
  message: string;
  url: string | null;
  height: number;
  file: string | null;
}
export const fetchCommonMessages = async (): Promise<CommonMessage[]> => {
  const {
    data
  } = await http.get(API_ENDPOINTS.COMMON_MESSAGE);
  return data;
};
export const useCommonMessagesQuery = () => {
  return useQuery<CommonMessage[], Error>('common-messages', fetchCommonMessages, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5
  });
};